// IMPORT BASE-MODULE
import BaseModule from '@core/modules/base-module/base-module';

// IMPORT CLASSES & MODULES
import SearchModal from '@core/components/modals/search-modal/search-modal';
import ScrollHandler from '@core/base/scripts/classes/ScrollHandler';
import ModalSearchInput from '@core/components/form/modal-search-input/modal-search-input';
import NavigationBar from '@pj/components/navigation/navigation-bar/navigation-bar';
import SwitchLang from '@core/components/dropdowns/switch-lang/switch-lang';

import '@pj/assets/images/svg/logo_dark.svg';
import AlertPopup from '@pj/components/alert-popup/alert-popup';

const navigationBar = new NavigationBar();
const menuModule = new BaseModule();
menuModule.name = 'header';
menuModule.revealOnScroll = false;
menuModule.init((that) => {
  /*
   * CLASSES INSTANCES
   */
  const alertPopup = new AlertPopup();
  alertPopup.init(that.elements);
  //
  navigationBar.init(that.elements);
  //
  const searchInput = new ModalSearchInput();
  searchInput.init();
  const searchModal = new SearchModal();
  searchModal.init('search-modal');
  /*
   * WINDOW SCROLL
   */
  const scrollHandler = new ScrollHandler();
  scrollHandler.init();
  scrollHandler.onScroll((down, scrollTop) => {
    if (down && navigationBar.isOpen() && scrollTop > navigationBar.subnavComponent.getHeight()) {
      navigationBar.closeSubnav();
    }
  });
});

menuModule.onResize(function () {
  if (navigationBar.isInit) {
    navigationBar.onResize();
  }
});
